import { createFeatureSelector } from '@ngrx/store';

import { assistanceFeatureName, AssistanceModuleState } from '@shared/travel-assistance/store/state/assistance.state';

export const assistanceRootSelector = createFeatureSelector<AssistanceModuleState>(assistanceFeatureName);
